import {create} from "zustand";
import {persist} from "zustand/middleware";

export type UserRole = "USER" | "LEADER" | "SALES_MANAGER" | "ADMIN";

export interface AuthUser {
  id: string;
  telegram_id: number;
  telegram_username?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  photo_url?: string | null;
  language_code: string;
  role?: UserRole;
  email?: string | null;
  phone_number?: string | null;
  referrer_display_name?: string | null;
  has_referral_binding?: boolean;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  hydrated: boolean;
  setSession: (session: {
    accessToken: string;
    refreshToken: string;
    user: AuthUser;
  }) => void;
  clear: () => void;
  setHydrated: (hydrated: boolean) => void;
}

export const useLandingAuth = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      hydrated: false,
      setSession: (session) =>
        set({
          accessToken: session.accessToken,
          refreshToken: session.refreshToken,
          user: session.user,
        }),
      clear: () =>
        set({
          accessToken: null,
          refreshToken: null,
          user: null,
        }),
      setHydrated: (hydrated) => set({ hydrated }),
    }),
    {
      name: "lidogon_landing_auth",
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        user: state.user,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHydrated(true);
      },
    },
  ),
);
